import { render, staticRenderFns } from "./PriceCurrency.vue?vue&type=template&id=2dc35a40&"
import script from "./PriceCurrency.vue?vue&type=script&lang=js&"
export * from "./PriceCurrency.vue?vue&type=script&lang=js&"
import style0 from "./PriceCurrency.vue?vue&type=style&index=0&id=2dc35a40&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports